export default __webpack_public_path__ + "static/media/Video-Player.c32c916f.png";